import { io } from 'socket.io-client';

// const SOCKET_SERVER_URL = "http://localhost:3005"
const SOCKET_SERVER_URL = "https://server.ibis.womi.ma"

export const socket = io(SOCKET_SERVER_URL);
